module.exports = __webpack_public_path__ + "static/life-regular-aaadf29142eea0ffd977647dbf50e754.woff";